import css from 'styled-jsx/css';
import { screen, colors } from 'components/styles/variables';

const BODY_TEXT_STYLES = `
   font-size: 18px;
   font-weight: 500;
   line-height: 1.39;
   letter-spacing: 0.2px;
`;

export default css`
  .article {
    padding: 0;
    background-color: white;
    box-shadow: 0 2px 5px 0 ${colors.G2};
    position: relative;
    padding: 0;
    background-color: white;
  }

  .below-hero {
    display: flex;
    align-items: strech;
    padding: 20px;
  }

  .body {
    padding-bottom: 45px;
    background-color: white;
    font-weight: 300;
  }

  .body.--with-hero {
    margin: 0;
    padding: 20px 10px;
  }

  @media (min-width: ${screen.smMin}) {
    .body.--with-hero {
      padding: 0px 35px 0px 10px;
    }

    .below-hero {
      padding: 25px 70px;
    }
  }

  .body .title {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: 0.2px;
  }

  @media (min-width: ${screen.smMin}) {
    .body .title {
      font-size: 34px;
      max-width: 500px;
    }
  }

  @media (min-width: ${screen.lgMin}) {
    .body {
      flex-grow: 1;
    }
  }

  .body .breaker {
    background: ${colors.G2};
    width: 50px;
    height: 5px;
    margin-top: 10px;
  }

  .body .info {
    line-height: 20px;
    padding-top: 10px;
    ${BODY_TEXT_STYLES};
  }

  // Special styled-jsx selector that makes these specific styles
  // global: https://github.com/zeit/styled-jsx#one-off-global-selectors
  .body :global(.content) {
    margin-top: 25px;
    ${BODY_TEXT_STYLES};
  }

  .body :global(.content h2) {
    font-size: 30px;
    font-weight: 600;
    padding-top: 14px;
  }

  .body :global(.content p) {
    margin: 10px 0px;
  }

  .body :global(.content ul) {
    list-style-type: square;
  }

  .body :global(.content li) {
    padding-bottom: 7px;
  }

  .body :global(.content img) {
    max-width: 100%;
    display: block;
    margin: 10px 0px;
  }

  .sharing.--top {
    padding-top: 10px;
  }

  .sharing.--bottom {
    padding: 20px 0 40px 0;
  }

  .body :global(.content a) {
    ${BODY_TEXT_STYLES};
  }

  .cta {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }

  .author-link {
    color: ${colors.ALR1};
    font-size: 16px;
  }

  .author-link:hover {
    color: ${colors.ALR1};
    text-decoration: underline;
  }

  .author-container {
    font-size: 16px;
  }
`;
